import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "app/store";

import { getData, postFile } from "features/dinamic";
import { setLoading } from "features/loader";
import { setVisible } from "features/modal";
import { setDataToast, setVisibleToast } from "features/toast";
import AlertInterface from "features/toast/toastInterface";


interface ModuloState {
    status: string;
    error: string;
    moduloList: any[],
    modulo: {
        idModulo: number | null;
        idCiclo: number | null;
        nombre: string | null;
        fileImage: string | null;
        fileData: string | null;
        sesionEncargadoList: [],
        sesionAlumnoList: [],
        ponderacionTareas: number | null;
        ponderacionEvaluaciones: number | null;
        pesoPre: number | null;
        pesoEval: number | null;
        pesoPost: number | null;
        estado: number | null;
    }

}

const initialState: ModuloState = {
    status: 'idle',
    error: '',
    moduloList: [],

    modulo: {
        idModulo: null,
        idCiclo: null,
        nombre: null,
        fileImage: null,
        fileData: null,
        sesionEncargadoList: [],
        sesionAlumnoList: [],
        ponderacionTareas: 70,
        ponderacionEvaluaciones: 30,
        pesoPre: 0,
        pesoEval: 40,
        pesoPost: 60,
        estado: null
    }
}

export const fetchModulo = createAsyncThunk('fetchModulo', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 68;
    const { result, message, data } = await getData({ idsp, idCiclo }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchFacilitadorModulo = createAsyncThunk('fetchFacilitadorModulo', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 120;
    const { result, message, data } = await getData({ idsp, idCiclo }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const fetchAlumnoModulo = createAsyncThunk('fetchAlumnoModulo', async ({ idCiclo }: any, { dispatch, getState, rejectWithValue }) => {
    const idsp = 203;
    const { result, message, data } = await getData({ idsp, idCiclo }, getState, dispatch);
    if (result) {
        return { data };
    }
    return rejectWithValue(message);
});

export const modifyCreateModulo = createAsyncThunk('modifyCreateModulo', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();

    const moduloNew = selectModulo(state);
    const moduloAttributes = {
        idModulo: moduloNew.idModulo,
        idCiclo: moduloNew.idCiclo,
        nombre: moduloNew.nombre,
        fileImage: moduloNew.fileImage,
        fileData: moduloNew.fileData,
        ponderacionTareas: moduloNew.ponderacionTareas,
        ponderacionEvaluaciones: moduloNew.ponderacionEvaluaciones,
        pesoPre: moduloNew.pesoPre,
        pesoEval: moduloNew.pesoEval,
        pesoPost: moduloNew.pesoPost
    };
    const idCiclo = moduloAttributes.idCiclo;
    const idsp = moduloAttributes.idModulo ? 66 : 65;
    let alert: AlertInterface;

    const { result, message, data } = await getData({ idsp, ...moduloAttributes }, getState, dispatch);
    if (result) {
        alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
        if (moduloAttributes.fileData !== null && moduloAttributes.fileData !== '') {
            const timestamp = Date.now();
            const fileName = `modulo_${data}_${timestamp}`;
            const { result } = await postFile({ idsp: 77, id: data, dir: "modulo", fileData: moduloAttributes.fileData, fileName: fileName }, getState, dispatch);
            if (!result) {
                alert = { title: 'ACCIÓN INCOMPLETA', message: "IMAGEN NO SE HA PODIDO GUARDAR", data: [], type: 'Crimson', time: Date.now() };
            }
        }
    }
    else {
        alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
    }
    dispatch(setDataToast(alert));
    dispatch(setVisibleToast(true));
    if (result) {
        dispatch(setVisible(false));
    }

    dispatch(setLoading(false));
    setTimeout(() => {
        dispatch(setVisibleToast(false));
    }, 4000);
    dispatch(fetchModulo({ idCiclo }));
    return rejectWithValue(message);
});

export const updateEstadoModulo = createAsyncThunk('updateEstadoModulo', async (_: any, { dispatch, getState, rejectWithValue }) => {
    const state: any = getState();
    const moduloNew = selectModulo(state);
    const moduloAttributes = { ...moduloNew }
    const estado = !moduloAttributes.estado;
    const idModulo = moduloAttributes.idModulo;
    const idCiclo = moduloAttributes.idCiclo;
    const idsp = 67;
    let alert: AlertInterface;

    try {
        const { result, message, data } = await getData({ idsp, estado, idModulo }, getState, dispatch);
        if (result) {
            alert = { title: 'CORRECTO..!', message: message, data: [], type: 'LimeGreen', time: Date.now() };
            dispatch(setDataToast(alert));
            dispatch(setVisibleToast(true));
            dispatch(setVisible(false));
            setTimeout(() => {
                dispatch(setVisibleToast(false));
            }, 4000);
            dispatch(fetchModulo({ idCiclo }));
        }
        else {
            alert = { title: 'ACCIÓN INCOMPLETA', message: message, data: data, type: 'Crimson', time: Date.now() };
            dispatch(setDataToast(alert));
            dispatch(setVisibleToast(true));
            setTimeout(() => {
                dispatch(setVisibleToast(false));
            }, 6000); // Más tiempo para errores
            // No cerrar el modal en caso de error para que el usuario pueda leer el mensaje
        }
    } catch (error: any) {
        // Manejo de errores de red o excepciones no controladas
        alert = {
            title: 'ERROR',
            message: 'Ocurrió un error inesperado al procesar la operación. Por favor, intenta nuevamente.',
            data: [],
            type: 'Crimson',
            time: Date.now()
        };
        dispatch(setDataToast(alert));
        dispatch(setVisibleToast(true));
        setTimeout(() => {
            dispatch(setVisibleToast(false));
        }, 6000);
    } finally {
        // Asegurar que siempre se desactive el loading, incluso si hay error
        dispatch(setLoading(false));
    }

    return rejectWithValue('Operation completed');
});

export const moduloSlice = createSlice({
    name: 'modulo',
    initialState,
    reducers: {
        setModuloList: (state, action) => {
            state.moduloList = action.payload;
        },
        setModulo: (state, action) => {
            state.modulo = !action.payload ? initialState.modulo : { ...initialState.modulo, ...action.payload };
        },
    },
    extraReducers(builder) {
        builder
            .addCase(fetchModulo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchModulo.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.moduloList = data ? data : [];

            })
            .addCase(fetchModulo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchFacilitadorModulo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchFacilitadorModulo.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.moduloList = data ? data : [];

            })
            .addCase(fetchFacilitadorModulo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })
            .addCase(fetchAlumnoModulo.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchAlumnoModulo.fulfilled, (state, action) => {
                const { data } = action.payload;
                state.status = 'completed';
                state.moduloList = data ? data : [];
            })
            .addCase(fetchAlumnoModulo.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload as string;
            })

    }
})

export const selectModuloList = (state: RootState) => state.modulo.moduloList;
export const selectModulo = (state: RootState) => state.modulo.modulo;

export const { setModuloList, setModulo } = moduloSlice.actions;

export default moduloSlice.reducer;
